import { lockBody, unlockBody, scrollLocker, SetVhElement } from "@plugins";

const options = {
    reserveScrollBarGap: true,
};

const header = document.querySelector(".js-header");
const dropdownMenuMob = document.querySelector(".js-dropdown-mob");
const headerHamburger = document.querySelector(".js-header-hamburger");
// const searchInners = document.querySelectorAll(".js-header-search-inner");
const searchWindow = document.querySelector(".js-header-search");
const searchActivate = document.querySelector(".js-open-search");
const searchClose = document.querySelector(".js-close-search");
const searchCloseMob = document.querySelector(".js-close-search-mob");

const buttons = [searchActivate, searchClose, searchCloseMob];

new SetVhElement(searchWindow);

function toggleModal() {
    if (!searchWindow.classList.contains("active")) {
        openModal();
    } else {
        closeModal();
    }
}

// function toggleSearchHelpers() {
//     if (searchInners) {
//         searchInners.forEach((searchInner) => {
//             const searchInput = searchInner.querySelector(".js-search-form-input");

//             if (searchInput) {
//                 const headerResultsBox = searchInner.querySelector(".js-search-results");
//                 const headerSearchTags = searchInner.querySelector(".js-header-search-tags");

//                 if (searchInput.value) {
//                     headerSearchTags.classList.add("hidden");
//                 } else {
//                     headerResultsBox.classList.add("hidden");
//                 }

//                 searchInput.oninput = () => {
//                     if (searchInput.value) {
//                         if (headerSearchTags) {
//                             headerSearchTags.classList.add("hidden");
//                         }

//                         if (headerResultsBox) {
//                             headerResultsBox.classList.remove("hidden");
//                         }
//                     } else {
//                         if (headerResultsBox) {
//                             headerResultsBox.classList.add("hidden");
//                         }

//                         if (headerSearchTags) {
//                             headerSearchTags.classList.remove("hidden");
//                         }
//                     }
//                 };
//             }
//         });
//     }
// }

function openModal() {
    if (searchWindow) {
        searchWindow.classList.add("active");
    }
    if (window.mobileMedia) {
        header.classList.add("search-opened");

        if (dropdownMenuMob.classList.contains("active")) {
            dropdownMenuMob.classList.remove("active");
            headerHamburger.classList.remove("is-active");
            if (!window.mobileMedia) {
                scrollLocker("unlock");
            } else {
                unlockBody();
            }
        }
    }
    if (!window.mobileMedia) {
        scrollLocker("lock");
    } else {
        lockBody(searchWindow, options);
    }
    // toggleSearchHelpers();
}

function closeModal() {
    if (searchWindow.classList.contains("active")) {
        searchWindow.classList.remove("active");
    }
    if (window.mobileMedia && header.classList.contains("search-opened")) {
        header.classList.remove("search-opened");
    }
    if (!window.mobileMedia) {
        scrollLocker("unlock");
    } else {
        unlockBody();
    }
}

if (buttons.length > 0) {
    for (const button of buttons) {
        button.addEventListener("click", () => {
            toggleModal();
        });
    }
}

document.addEventListener("keyup", (e) => {
    if (e.key === "Escape" && searchWindow.classList.contains("active")) {
        toggleModal();
    }
});
